(function($, root) {
  function escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function escapeTags(unsafe) {
    return unsafe
      .replace(/"/g, " ")
      .replace(/“/g, " ")
      .replace(/”/g, " ")
      .replace(/<br>/g, " ")
      .replace(/<br\/>/g, " ")
      .replace(/<br \/>/g, " ")
      .replace(/'/g, " ");



  }

  $.hexToRgbA = function(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
    }
    throw new Error('Bad Hex');
  }

  function colorToOpacity(color, opacity) {

    return $.hexToRgbA(this.tagCtx.props.color, this.tagCtx.props.opacity);
  }

  function urlEncode(text) {
    return encodeURI(text);

  }

  function htmlEncode(text) {
    return escapeHtml(text);
  }

  function stripTags(text) {
    return escapeTags(text);
  }

  // $.views.settings.allowCode(true);
  $.views.tags("opacity", colorToOpacity);

  $.views.tags("urlencode", urlEncode);

  $.views.tags("htmlencode", htmlEncode);

  $.views.tags("striptags", stripTags);

})(jQuery, this);
